import firebase from "firebase/compat/app";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFunctionsEmulator, getFunctions, httpsCallable } from "firebase/functions";
import { getApp } from "firebase/app";
import { connectStorageEmulator, getStorage } from "firebase/storage";
import { getMessaging, isSupported } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBbRtsi7hR3PQirKWrWFk8uL3W6YA9SRXA",
  authDomain: "funparliament-8d837.firebaseapp.com",
  databaseURL: "https://funparliament-default-rtdb.firebaseio.com",
  projectId: "funparliament-8d837",
  storageBucket: "funparliament-8d837.firebasestorage.app",
  messagingSenderId: "990539324238",
  appId: "1:839366544010:web:17ac42a8b2638683037b73",
  measurementId: "G-75PE65YND1"
};


const funParliament = firebase.initializeApp(firebaseConfig, 'funParliament');

export const messaging = (async () => {
  try {
    const isSupportedBrowser = await isSupported();
    if (isSupportedBrowser) {
      return getMessaging();
    }
    console.log('SportFirebase not supported this browser');
    return null;
  } catch (err) {
    console.log(err);
    return null;
  }
})();
export const db = getFirestore(funParliament);
export const auth = getAuth();
export const functions = getFunctions(getApp());
export const storage = getStorage();
export const assignFunParliament = httpsCallable(functions, "assignReferrer");
export default funParliament;
